import { useContext, useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { 
    SidePopupContainer, FlexColumn, Button, 
    FlexRow, AppSpan, AppText, GridContainer, CustomContainer 
} from "src/style"
import { RiCloseFill } from "react-icons/ri"
import { ReactComponent as DecisionBoxIcon } from 'src/assets/img/decision-box-icon.svg'
import { moneyFormat } from "src/utils/utility"

export const InstallationConfirmation: React.FC<any> = ({product, getProductUpdate, close}) => {
    const {API} = useContext(ApiContext)
    const [billingConfig, setBillingConfig] = useState<any>(null)

    useEffect(() => {
        handleFetchBillingConfig()
    }, [])

    async function handleFetchBillingConfig () {
        const response = await API.getBillingConfiguration()
        if (response) setBillingConfig(response)
    }

    async function handleSubmit () {
        const response = await API.installProduct(product.id)
        if (response) {
            getProductUpdate()
            close()
        }
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Installation Confirmation</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <GridContainer topMargin="2">
                    <DecisionBoxIcon className="icon-component" />
                </GridContainer>
                <AppText 
                    fontWeight="300" color="#101828" 
                    topMargin="1.5"
                >
                    Please review the following details before proceeding with the installation. 
                    By clicking ‘Yes,   continue' you agree to the installation and the associated charges.
                </AppText>
                <CustomContainer 
                    topMargin="3.5" borderColor="#F9FAFB"
                    radius="0.8" bgColor="#F9FAFB"
                    shadow="0px 1px 2px 0px #1018280D"
                    padding="1.6"
                >
                    <FlexRow 
                        justifyContent="space-between" gap="1" 
                        wrap="wrap"
                    >
                        <AppText color="#000000">Product cost</AppText>
                        <AppText color="#000000" fontWeight="600">N{moneyFormat(product?.setupFee || 0)}</AppText>
                    </FlexRow>
                    <FlexRow 
                        justifyContent="space-between" gap="1" 
                        wrap="wrap" topMargin="1"
                    >
                        <AppText color="#000000">Amount debited from</AppText>
                        <AppText color="#000000" fontWeight="600">{billingConfig?.expenseGL}</AppText>
                    </FlexRow>
                </CustomContainer>
                
                <FlexRow justifyContent='flex-end' gap='1' topMargin="2">
                    <Button 
                        width='8.1' height='4' bgColor="#ffffff"
                        borderColor='#D0D5DD' 
                        hoverBgColor='#ffffff' color="#344054"
                        hoverColor='#0D968F' titleSize='1.4'
                        onClick={close}
                    >
                        Cancel
                    </Button>
                    <Button
                        width='12.3'
                        titleSize='1.4' fontWeight="500"
                        height='4' radius='0.8'
                        hoverColor='#0D968F'
                        hoverBgColor='#fff' borderColor='#0D968F'
                        onClick={handleSubmit}
                    >
                        Yes, confirm
                    </Button>
                </FlexRow>
            </FlexColumn>
        </>
    )
}